export const TEST_ID = 'stripeSubscriptionSummary';

export const STRIPE_PREMIER_PRICING_TABLE_ID = import.meta.env.VITE_STRIPE_PREMIER_PRICING_TABLE_ID;

export const STRIPE_PRICING_TABLE_PUBLISHABLE_KEY = import.meta.env
    .VITE_STRIPE_PRICING_TABLE_PUBLISHABLE_KEY;
